import React, { useRef, useEffect, useState } from "react";
import html2pdf from "html2pdf.js";
import { useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-hot-toast";
import config from "../../config";


const PreIntimationLetter = () => {
  const letterRef = useRef();

  const { agreementNo: encodedAgreementNo } = useParams();

    const agreementNo = encodedAgreementNo? atob(encodedAgreementNo) : "";
    // alert(agreementNo);

    const [letterData, setLetterData] = useState(null);
    const [loading, setLoading] = useState(false);

  const getPdfOptions = () => ({
    margin: [0.2, 0.2, 0.2, 0.2],
    filename: `Post_Intimation_Letter.pdf`,
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, letterRendering: true },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  });

  const handleDownloadPdf = () => {
    html2pdf().set(getPdfOptions()).from(letterRef.current).save();
  };

  const handlePreview = () => {
    html2pdf()
      .set(getPdfOptions())
      .from(letterRef.current)
      .outputPdf("bloburl")
      .then((url) => {
        window.open(url, "_blank");
      });
  };

const getPreIntimationLetterData = async () => {
  try {
    setLoading(true);

    const formData = new FormData();
    formData.append("agreement_no", agreementNo);

    console.log("Agreement No :", agreementNo);
    console.log(
      "API URL :",
      `${config.API_BASE_URL}get-pre-intimation-letter-data`
    );

    const response = await axios.post(
      `${config.API_BASE_URL}get-pre-intimation-letter-data`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    console.log("API Response :", response);

    if (response.data.status) {
      setLetterData(response.data.data);
      console.log(
        "Post Intimation Data =>",
        response.data.data
      );

      // toast.success("Data fetched successfully");
    } else {
      console.log("API Error :", response.data.message);
      toast.error(response.data.message);
    }
  } catch (error) {
    console.log("Catch Error :", error);
    console.log("Error Response :", error?.response);
    console.log("Error Data :", error?.response?.data);

    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"
    );
  } finally {
    setLoading(false);
  }
};

useEffect(() => {
  if (agreementNo) {
    getPreIntimationLetterData();
  }
}, [agreementNo]);

  return (
    <div
      style={{
        backgroundColor: "#f9fafb",
        minHeight: "100vh",
        fontFamily: "Arial, sans-serif",
      }}
    >
      {/* Header section */}
      <div
        style={{
          padding: "20px 40px",
          backgroundColor: "#ffffff",
          marginBottom: "20px",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
        }}
      >
        <h2
          style={{
            fontSize: "22px",
            fontWeight: "bold",
            margin: "0 0 20px 0",
          }}
        >
          Post Intimation Letter
        </h2>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "15px",
          }}
        >
          <button
            onClick={handlePreview}
            style={{
              backgroundColor: "#00b8d4",
              color: "#fff",
              border: "none",
              padding: "10px 24px",
              borderRadius: "6px",
              fontSize: "12px",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            PREVIEW
          </button>
          <button
            onClick={handleDownloadPdf}
            style={{
              backgroundColor: "#ffb300",
              color: "#fff",
              border: "none",
              padding: "10px 24px",
              borderRadius: "6px",
              fontSize: "12px",
              fontWeight: "bold",
              cursor: "pointer",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
          >
            DOWNLOAD PDF
          </button>
        </div>
      </div>

      {/* Letter Content Container */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          paddingBottom: "60px",
        }}
      >
        <div
          ref={letterRef}
          style={{
            width: "740px",
            minHeight: "1040px", 
            border: "1px solid #000",
            padding: "40px 40px",
            backgroundColor: "#fff",
            boxSizing: "border-box",
            color: "#000",
            fontSize: "12px",
            lineHeight: "1.5",
            position: "relative",
          }}
        >
          {/* Logo & Company Header */}
          <div style={{ textAlign: "center", marginBottom: "5px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "8px",
              }}
            >
              <img
                src="/assets/ckern-logo.png"
                alt="cKers Finance"
                style={{ height: "55px" }}
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "15px",
                marginBottom: "4px",
                color: "#003366",
              }}
            >
              cKers Finance Private Limited
            </div>
            <div style={{ fontSize: "11px", fontWeight: "500" }}>
              Building No-24-30,First Floor, Okhla Industrial Estate,Phase-III,
              New Delhi 110020, INDIA
            </div>
            <div style={{ fontSize: "11px", fontWeight: "500" }}>
              Phone +91-11-41070629 contact@ckersfinance.in
            </div>
          </div>

          <div
            style={{
              borderBottom: "1px solid #000",
              margin: "15px 0",
            }}
          />

          <div
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "13px",
              marginBottom: "30px",
            }}
          >
            Information to the Police Station about Possession-POST Intimation
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "30px",
            }}
          >
            <div style={{ flex: 1, paddingRight: "20px", minWidth: 0 }}>
              <div style={{ marginBottom: "2px" }}>To</div>
              <div style={{ marginBottom: "20px" }}>The S.H.O</div>

              <div
                contentEditable
                suppressContentEditableWarning
                style={{
                  width: "100%",
                  border: "none",
                  outline: "none",
                  fontFamily: "inherit",
                  fontSize: "inherit",
                  backgroundColor: "transparent",
                  padding: 0,
                  margin: 0,
                  display: "block",
                  lineHeight: "1.5",
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  wordBreak: "break-word",
                }}
              >
                Police station Amrapali Platinum, Sector 119, Noida,
                <br />
                Uttar Pradesh 201316
              </div>
              <div style={{ borderBottom: "1px solid #000", width: "180px", marginTop: "15px" }}/>
            </div>

            <div style={{ width: "160px" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      textAlign: "left",
                      width: "45%",
                      paddingBottom: "5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    DD No
                  </td>

                  <td
                    style={{
                      textAlign: "left",
                      width: "55%",
                      paddingBottom: "5px",
                    }}
                  >
                    <div
                      contentEditable
                      suppressContentEditableWarning
                      style={{
                        outline: "none",
                        display: "inline-block",
                        minWidth: "80px",
                      }}
                    >
                      ckers103
                    </div>
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Dated
                  </td>

                  <td
                    style={{
                      textAlign: "left",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {new Date().toLocaleDateString("en-GB").replace(/\//g, "-")}
                  </td>
                </tr>
              </tbody>
              </table>
            </div>
          </div>

          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginBottom: "30px",
              border: "1px solid #000",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    width: "35%",
                  }}
                >
                  Dear Sir,
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                />
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Subject:
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center"
                  }}
                >
                  POST Intimation of Repossed Vehicle
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Borrower's Name
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center"
                  }}
                >
                  {letterData?.borrower_name || ""}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Address
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center"
                  }}
                >
                  <div style={{ whiteSpace: "pre-wrap" }}>
                    {letterData?.borrower_address || ""}
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Loan Agreement No.
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center"
                  }}
                >
                  {letterData?.agreement_no || ""}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Vehicle Make
                </td>
               <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center",
                  }}
                >
                  <div
                    contentEditable
                    suppressContentEditableWarning
                    style={{
                      outline: "none",
                      minHeight: "18px",
                      width: "100%",
                      display: "block",
                    }}
                  >
                    {letterData?.vehicle_make || ""}
                  </div>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Vehicle Reg.No.
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center"
                  }}
                >
                  {letterData?.vehicle_reg_no || ""}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Engine No.
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center"
                  }}
                >
                  {letterData?.engine_no || ""}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                  }}
                >
                  Chassis No.
                </td>
                <td
                  style={{
                    border: "1px solid #000",
                    padding: "6px 10px",
                    textAlign: "center"
                  }}
                >
                  {letterData?.chassis_no || ""}
                </td>
              </tr>
            </tbody>
          </table>

          <div style={{ marginBottom: "30px", textAlign: "justify" }}>
            The above Borrower has defaulted on the scheduled repayment of loan
            and has thereby failed to, company with the terms and conditions of
            the agreement.Pursuant to our rights of the above cited Loan cum
            Hypothecation Agreement, we have taken then possession of the
            captioned asset on...28-05-2026 (Date). Which was vehicle surrender
            by customer.
          </div>

          <div style={{ marginBottom: "40px", textAlign: "justify" }}>
            This communication is for your record and to prevent any confusion
            that may arise from any complaint that Borrower may lodge with you
            about the aforesaid asset. Kindly do not take cognizance of any
            complaint lodge by Borrower.
          </div>

          <div style={{ marginBottom: "5px" }}>Sincerely.</div>
          <div style={{ fontWeight: "bold", marginBottom: "40px" }}>
            For ckers Finance Private Ltd.
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "40px",
              left: "40px",
              fontWeight: "bold",
            }}
          >
            Authorized signatories
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreIntimationLetter;